import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { Badge } from '@/components/ui/badge';
import { queryClient } from '../../../../App';
import { getStore } from '../../../../store/store';
import type { OrgEvent } from 'hooks/orgEvents/orgEventHooks';
import { cn } from '@/lib/utils';
import { OrgEventDetailsBody } from './OrgEventDetailsBody';
import { severityBadgeClass } from './severityBadgeClass';

type OrgEventPopupContentProps = {
  event: OrgEvent;
};

function OrgEventPopupContentInner({ event }: OrgEventPopupContentProps) {
  return (
    <div className="dark tw:max-w-[420px] tw:space-y-2 tw:bg-background tw:p-1 tw:text-foreground">
      <div className="tw:flex tw:flex-wrap tw:items-center tw:gap-1.5">
        <Badge className={cn('tw:shrink-0', severityBadgeClass(event.severity))}>
          {event.severity || 'Medium'}
        </Badge>
        <Badge variant="outline" className="tw:shrink-0">
          {event.status || 'Active'}
        </Badge>
      </div>
      <p className="tw:m-0 tw:text-sm tw:font-medium">{event.name}</p>
      <p className="tw:m-0 tw:text-xs tw:text-muted-foreground">
        {[event.type, event.region].filter(Boolean).join(' · ') || 'Org event'}
      </p>
      <OrgEventDetailsBody event={event} />
    </div>
  );
}

export function OrgEventPopupContent(props: OrgEventPopupContentProps) {
  const store = getStore();

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <OrgEventPopupContentInner {...props} />
      </QueryClientProvider>
    </Provider>
  );
}
